<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="p-grid">
    <div class="p-col-12 map">
        <p-gmap #gmap [style]="{'width':'100vw','height':'100vh'}" [options]="options" [overlays]="overlays"
            (onMapClick)="handleMapClick($event)" (onOverlayClick)="handleOverlayClick($event)"
            (onOverlayDragEnd)="handleDragEnd($event)">
        </p-gmap>
    </div>
    <div class="p-col-4">
        <div class="card map-card_options" style="overflow: hidden;">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-d-flex p-ai-left p-jc-between">
                        <button style="background-color: white; color: black;" type="button" pButton icon="pi pi-globe"
                            (click)="clear()"></button>
                        <button style="background-color: white; color: black;" type="button" pButton icon="pi pi-home"
                            (click)="clear()"></button>
                        <button style="background-color: white; color: black;" type="button" pButton icon="pi pi-user"
                            (click)="clear()"></button>
                        <button style="background-color: white; color: black;" type="button" pButton icon="pi pi-plus"
                            (click)="zoomIn(gmap.getMap())"></button>
                        <button style="background-color: white; color: black;" type="button" pButton icon="pi pi-minus"
                            (click)="zoomOut(gmap.getMap())"></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card map-card_detail" style="overflow: hidden;">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-fluid">
                        <div class="p-col-12">
                            <label for="statusModal">Identificador</label>
                            <input id="selectedNameInput" value="0000666584" disabled="true" type="text" maxlength="30"
                                pInputText placeholder="Seleccione un lenguaje">
                        </div>
                        <div class="p-col-12">
                            <label for="statusModal">Coordinación </label>
                            <input id="selectedNameInput" value="Internacional" disabled="true" type="text"
                                maxlength="30" pInputText placeholder="Seleccione un lenguaje">
                        </div>
                        <div class="p-col-12">
                            <label for="statusModal">Dirección</label>
                            <input id="selectedNameInput" value="Calle #12 Av. 16 Septiembre" disabled="true"
                                type="text" maxlength="30" pInputText placeholder="Seleccione un lenguaje">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card map-card">
            <p-table #dt [columns]="cols" [value]="data" [paginator]="true" [rows]="rowsPerPage"
                [showCurrentPageReport]="false" [globalFilterFields]="colsGlobal">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{ capitalizeLastElement(col.header) }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                            {{ getNestedValue(rowData, col.field) }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<p-dialog showEffect="fade" [(visible)]="dialogVisible" header="New Location" [style]="{width: '300px'}">>
    <div class="p-grid p-fluid" *ngIf="selectedPosition">
        <div class="p-col-2"><label for="title">Label</label></div>
        <div class="p-col-10"><input type="text" pInputText id="title" [(ngModel)]="markerTitle"></div>

        <div class="p-col-2"><label for="lat">Lat</label></div>
        <div class="p-col-10"><input id="lat" type="text" readonly pInputText [ngModel]="selectedPosition.lat()"></div>

        <div class="p-col-2"><label for="lng">Lng</label></div>
        <div class="p-col-10"><input id="lng" type="text" readonly pInputText [ngModel]="selectedPosition.lng()"></div>

        <div class="p-col-2"><label for="drg">Drag</label></div>
        <div class="p-col-10"><p-checkbox [(ngModel)]="draggable" binary="true"
                [style]="{'margin-top':'.25em'}"></p-checkbox></div>
    </div>
    <ng-template pTemplate="footer">
        <div>
            <button type="button" pButton label="Add Marker" icon="pi-plus" (click)="addMarker()"></button>
        </div>
    </ng-template>
</p-dialog>